import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, useBreakpointValue, useTokens } from "@gemini/core";
import Map from "react-map-gl/mapbox";
import { useMapboxToken } from "@/contexts/cdpConfig";
import { useMapContext } from "../../contexts/MapContext";
import { DEFAULT_ZOOM, MAP_ID, MAP_STYLES, SIDEBAR_WIDTH, } from "../../constants";
import { MapSidebar } from "./MapSidebar";
import { MapBottomSheet } from "./MapBottomSheet";
import { PinMarker } from "../SourcesAndLayers/PinMarker";
import { MapContactEntry } from "../QuickActions/ContactEntry/MapContactEntry";
import { MapControlsContainer } from "../QuickActions/Controls/MapControlsContainer";
import { MapSettings } from "../QuickActions/Settings/MapSettings";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { MapHandler } from "./MapHandler";
import { MapLayers } from "../Map/MapLayers";
import { NavigationTopBar } from "@/components/UI/NavigationTopBar/NavigationTopBar";
import { useGetBaseRoute } from "@/app/router/hooks/useGetBaseRoutes";
import { useCdpNavigate } from "@/app/router/hooks/useCdpNavigate";
import { useI18n } from "@/shared/hooks/useI18n/useI18n";
import { SocialAndPrintCTAs } from "@/shared/components/SocialAndPrintCTAs";
import { MapError } from "./MapError";
import { ThorView } from "@aviv-dxp/react-thor";
import { useTrackingViewMap } from "@/hooks/tracking/useTrackingViewMap";
export const MapContainer = () => {
    const { t } = useI18n();
    const accessToken = useMapboxToken();
    const { languageTag } = useLocale();
    const { viewport, style, isSidebarOpen, setIsStyleLoaded, setInitialLights, error, handleClose, } = useMapContext();
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    const trackingViewData = useTrackingViewMap();
    const tokens = useTokens();
    const headline = t("location.map.modal.title");
    const navigate = useCdpNavigate();
    const baseRoute = useGetBaseRoute();
    const navigateBack = () => {
        handleClose();
        navigate(baseRoute());
    };
    return (_jsxs(Box, { position: {
            "breakpoint.base": "fixed",
            "breakpoint.md": "initial",
        }, width: "100%", height: "100%", children: [_jsx(NavigationTopBar, { headline: headline, additionalCTAs: _jsx(SocialAndPrintCTAs, { variant: "tertiary" }), navigateBack: navigateBack, buttonLabel: t("gallery.modal.back.cta") }), _jsxs(Box, { height: `calc(100dvh - ${tokens["sizing.64"]})`, width: {
                    "breakpoint.base": "100vw",
                    "breakpoint.lg": "100%",
                }, overflow: "hidden", position: "relative", children: [_jsx(ThorView, { viewProps: trackingViewData }), error && _jsx(MapError, {}), !error && (_jsxs(_Fragment, { children: [_jsx(ThorView, { viewProps: trackingViewData }), _jsx(MapSidebar, {}), _jsx(Box, { position: "absolute", top: "0", right: "0", height: "100%", width: isSidebarOpen && !isMobile
                                    ? `calc(100% - ${SIDEBAR_WIDTH}px)`
                                    : "100%", children: _jsxs(Map, { id: MAP_ID, mapboxAccessToken: accessToken, initialViewState: {
                                        bounds: viewport.bounds,
                                        zoom: DEFAULT_ZOOM,
                                    }, style: { width: "100%", height: "100%" }, mapStyle: `mapbox://styles/mapbox/${style === MAP_STYLES.THREE_DIMENSIONAL
                                        ? MAP_STYLES.STANDARD
                                        : style}`, onLoad: (e) => {
                                        var _a;
                                        setIsStyleLoaded(true);
                                        const map = e.target;
                                        setInitialLights((_a = map.getLights()) !== null && _a !== void 0 ? _a : []);
                                        map.on("style.load", () => {
                                            console.log("🗺️ map style on load");
                                            setIsStyleLoaded(true);
                                        });
                                    }, language: languageTag, reuseMaps: true, children: [_jsx(MapHandler, {}), _jsx(PinMarker, {}), _jsx(MapLayers, {}), _jsx(MapSettings, {}), _jsx(MapControlsContainer, {})] }) }), _jsx(MapContactEntry, {}), _jsx(MapBottomSheet, {})] }))] })] }));
};
